export default {
    title: 'Aid Each Child Fullfil Their Dreams',
    safeItems: [
        'Convenient Transportation',
        'Open Plan Office',
        'Enjoyable working atmosphere'
    ],
    bottomTitle: 'Currently Hiring',
}